import { memo } from 'react';
import classNames from 'classnames';
import Image from 'components/Image';
import styles from './TerpeneCard.module.scss';

const TerpeneCard = ({ aromas, className, imageUrl, title, useCases }) => (
  <li
    className={classNames(
      'bg-cream d-flex flex-column p-14 p-sm-21 p-md-10 p-lg-15 p-xl-10 p-xxl-15 text-center text-primary',
      styles.container,
      className
    )}
    data-value="terpene-card"
  >
    <span className={`d-inline-block mx-auto ${styles.image_wrapper}`}>
      <Image alt={title} height={120} src={imageUrl} width={120} />
    </span>
    <h3
      className={`font-sofia fs-10 fs-xxl-12 fw-700 mt-18 mb-12 text-uppercase text-primary ${styles.title}`}
    >
      {title}
    </h3>
    <ul className="list-unstyled">
      {aromas ? (
        <li className="d-flex flex-column fs-7 fs-sm-8 mb-12">
          <strong className="fw-700 text-uppercase">Aromas:</strong>
          <p className="my-0">{aromas}</p>
        </li>
      ) : null}
      {useCases ? (
        <li className="d-flex flex-column fs-7 fs-sm-8">
          <strong className="fw-700 text-uppercase">Use Cases:</strong>
          <p className="my-0">{useCases}</p>
        </li>
      ) : null}
    </ul>
  </li>
);

export default memo(TerpeneCard);
